<template>
  <div class="initiative-details-footer d-flex mt-50">
    <span v-if="$vuetify.breakpoint.smAndUp" class="upperBackground">{{this.nameSplit[0]}}</span>
    <span v-if="$vuetify.breakpoint.smAndUp" class="lowerBackground">{{this.nameSplit[1]}}</span>

    <router-link v-if="$vuetify.breakpoint.smAndUp" class="left generic-image-link" :to="{name:'InitiativesDetails', params: {slug: prevProject._slug}}">
      <seo-v-img cover width="400" :aspect-ratio="0.8" :src="`/media/${prevProject.image.id}`" ><div class="image-dark-cover" /></seo-v-img>
      <div class="wrapper">
        <span class="label">{{$root.siteSettings.previousLabel}}</span>
        <span class="link" >{{prevProject.name}}</span>
      </div>
    </router-link>

    <router-link class="right generic-image-link" :to="{name:'InitiativesDetails', params: {slug: nextProject._slug}}">
      <seo-v-img v-if="$vuetify.breakpoint.smAndUp" cover width="400" :aspect-ratio="0.8" :src="`/media/${nextProject.image.id}`"><div class="image-dark-cover" /></seo-v-img>
      <div class="wrapper">
        <span class="label">{{$root.siteSettings.nextLabel}}</span>
        <span class="link"  >{{nextProject.name}}</span>
      </div>
    </router-link>

  </div>
</template>

<script>
export default {
  name: 'InitiativesDetailFooter',
  props: {
    nextProject: {
      type: Object,
      required: true
    },
    prevProject: {
      type: Object,
      required: true
    }
  },
  computed: {
    nameSplit () {
      return this.$root.siteSettings.initiativesPageTitle.split(' ')
    }
  }
}
</script>

<style scoped lang="scss">
.mt-50 {
  margin-top: 200px;
}

.initiative-details-footer {
  padding: 100px 30px;
  background-color: $c-pink;
  min-height: 320px;
  position: relative;
  justify-content: space-evenly;

  .lowerBackground,
  .upperBackground {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    font-size: 9rem;
    font-family: $heading-font-family;
    color: rgba(255, 255, 255, 0.15);
  }

  .upperBackground {
    top: 10px;
  }

  .lowerBackground {
    bottom: 10px;
  }

  .label {
    display: block;
    color: #fff;
    font-family: $body-font-family;
    font-size: 1.1rem;
  }

  .wrapper {
    position: absolute;
    top: 90%;
    transform: translateY(-30%);

    @include breakpoint('xs-only') {
      position: relative;
      top: 0;
      transform: none;
    }
  }

  .link {
    color: #f4f4f8;
    font-family: $heading-font-family;
    font-size: 4.5vh;
    max-width: 230px;
    display: inline-block;
    line-height: 1.3;
    hyphens: auto;
  }

  .left {
    position: relative;

    .wrapper {
      left: -5%;
    }
  }

  .right {
    position: relative;
    text-align: right;

    @include breakpoint('xs-only') {
      text-align: left;
    }

    .wrapper {
      right: -5%;
      @include breakpoint('xs-only') {
        right: auto;
      }
    }
  }
}
</style>
